var map = {
	"./attachments-section/attachments-section": "@rightship-tech/document-management-app/views/pages/form-viewer/sections/attachments-section/attachments-section",
	"./attachments-section/attachments-section.html": "@rightship-tech/document-management-app/views/pages/form-viewer/sections/attachments-section/attachments-section.html",
	"./attachments-section/attachments-section.scss": 85279,
	"./attachments-section/attachments-section.ts": "@rightship-tech/document-management-app/views/pages/form-viewer/sections/attachments-section/attachments-section"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11710;